import React, { Component } from "react";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import MediaItem from './MediaItem';
import { Link } from 'react-router-dom';

export default class MediaItems extends Component {
	  	
	render () {
		
		let items = this.props.items;
		
		
		
		if (items) {
										
		    return (
		
			    <div className="c-page__block c-page__block--inset-mobile c-page__block--load-effect">
					
					<div className="l-grid">
			    
			    		<div className="l-grid__col">
			    		
			    			<div className="c-press">
			    			
								{items.map((item,i) =>
									{
										return (
											
											<MediaItem item={item} index={i} key={i}></MediaItem>
											
										)
									}				
								)}
								
							</div>
					    
					    </div>
					    
					</div>
			    
			    </div>
			)
			
		} else {
			
			return null
			
		}
	}
}
